import { Text, View } from '@react-pdf/renderer';
import { sharedStyles } from './sharedStyles';
import ContentRenderer from './ContentRenderer';
import type { AssessmentReportAssessmentQuestion } from './types';

interface OpenQuestionItemProps {
  question: AssessmentReportAssessmentQuestion;
  userInput: string;
  correct: boolean;
  feedback?: string | null;
}

function OpenQuestionItem({
  question,
  userInput,
  correct,
  feedback,
}: OpenQuestionItemProps): React.ReactElement {
  return (
    <View style={sharedStyles.itemContainer}>
      <View style={sharedStyles.itemHeader}>
        <Text style={sharedStyles.itemTitle}>
          {question.position}. {question.title}
        </Text>
        <View style={correct ? sharedStyles.resultBadgeCorrect : sharedStyles.resultBadgeIncorrect}>
          <Text style={sharedStyles.resultBadgeText}>{correct ? 'CORRECT' : 'INCORRECT'}</Text>
        </View>
      </View>

      {question.questionContentFormatted && question.questionContentFormatted.length > 0 ? (
        <ContentRenderer content={question.questionContentFormatted} />
      ) : null}

      <View style={sharedStyles.answerSection} wrap={false}>
        <Text style={sharedStyles.answerText}>{userInput || 'No answer provided'}</Text>
      </View>

      {feedback != null && feedback.length > 0 ? (
        <View style={sharedStyles.feedbackSection} wrap={false}>
          <Text style={sharedStyles.feedbackLabel}>ASSESSOR FEEDBACK</Text>
          <Text style={sharedStyles.feedbackText}>{feedback}</Text>
        </View>
      ) : null}
    </View>
  );
}

export default OpenQuestionItem;
